module.exports = __webpack_public_path__ + "img/0.4eed9f1b.jpg";